module.exports = __webpack_public_path__ + "static/media/bannerDefault.aca2a84d.png";